<template>
  <div class="container">
    <div class="left-part">
      <div class="title-bloc">
        <div class="title">
          <h1>À LA RESCOUSSE DE LESTRADE</h1>
        </div>
        <div class="subtitle-bloc">
          <div class="subtitle">
            <Chronometer />
          </div>
          <div class="subtitle">
            <h2>🕯 {{ hints }}</h2>
          </div>
        </div>
      </div>
      <div class="images">
        <div style="position: relative;" v-if="day == 0">
          <img src="../assets/Gipsy/lestrade.png" class="illustration" />
        </div>
        <div style="position: relative;" v-if="day == 1">
          <img src="../assets/Gipsy/box.png" class="elements" id="box" @click="toggleBox" />
          <img src="../assets/Gipsy/lestrade.png" class="illustration" />
        </div>
        <div style="position: relative;" v-if="day == 2">
          <img src="../assets/Gipsy/table.png" id="table" class="inactive" />
          <img
            src="../assets/Gipsy/crystal_ball.png"
            class="elements"
            id="table_ball"
            @click="toggleCrystal"
          />
          <img src="../assets/Gipsy/cards.png" id="wall_cards" class="inactive" />
          <img src="../assets/Gipsy/case.png" id="wall_case" class="inactive" />
          <img src="../assets/Gipsy/seer.png" class="illustration" />
        </div>

        <div style="position: relative;" v-if="day == 3">
          <img src="../assets/Gipsy/table.png" id="table" class="inactive" />
          <img
            src="../assets/Gipsy/ouija.png"
            class="elements"
            id="table-ouija"
            @click="toggleOuija"
          />
          <img src="../assets/Gipsy/crystal_ball.png" id="wall_ball" class="inactive" />
          <img src="../assets/Gipsy/cards.png" id="wall_cards" class="inactive" />
          <img src="../assets/Gipsy/case.png" id="wall_case" class="inactive" />
          <img src="../assets/Gipsy/seer.png" class="illustration" />
        </div>
        <div style="position: relative;" v-if="day == 4">
          <img src="../assets/Gipsy/table.png" id="table" class="inactive" />
          <img
            src="../assets/Gipsy/cards.png"
            class="elements"
            id="table-cards"
            @click="toggleCards"
          />
          <img src="../assets/Gipsy/crystal_ball.png" id="wall_ball" class="inactive" />
          <img src="../assets/Gipsy/case.png" id="wall_case" class="inactive" />
          <img src="../assets/Gipsy/seer.png" class="illustration" />
        </div>
        <div style="position: relative;" v-if="day == 5">
          <img src="../assets/Gipsy/case.png" class="elements" id="case" @click="toggleCase" />
          <img src="../assets/Gipsy/crystal_ball.png" id="wall_ball" class="inactive" />
          <img src="../assets/Gipsy/seer.png" class="illustration" />
          <img src="../assets/Gipsy/cards.png" id="wall_cards" class="inactive" />
        </div>

        <transition name="fade">
          <Notes
            class="notes"
            v-if="displayNotes"
            @toggleNote="toggleNote()"
            @update="notesContent = $event"
            :content="notesContent"
          />
          <Victory
            class="victory-modale"
            v-if="victory"
            :startTime="startTime"
            :hints="hints"
            :userName="userName"
            @update="closeModale($event)"
          />
        </transition>
        <div class="calendar-container">
          <Calendar
            @chooseDay="day = $event"
            @toggleOne="toggleOne"
            @toggleTwo="toggleTwo"
            @toggleThree="toggleThree"
            @toggleFour="toggleFour"
            @toggleFive="toggleFive"
          />
        </div>
        <img src="../assets/Gipsy/envelope.png" id="envelope" class="helpers" @click="toggleIntro" />
        <img src="../assets/Gipsy/note.png" id="note" class="helpers" @click="toggleNote" />
        <img
          src="../assets/Gipsy/lestrade_card.png"
          id="lestrade_card"
          class="helpers"
          @click="toggleLestrade"
        />
      </div>
    </div>
    <div class="infos">
      <transition name="fade">
        <Intro v-if="displayIntro" />
        <OneIntro v-if="displayOne" />
        <Box
          v-if="displayBox"
          :hintList="hintList"
          @updateHints="hintList = $event"
          @incrementCounter="hints += 1"
        />
        <TwoIntro v-if="displayTwo" />
        <Crystal
          v-if="displayCrystal"
          :hintList="hintList"
          @updateHints="hintList = $event"
          @incrementCounter="hints += 1"
        />
        <ThreeIntro v-if="displayThree" />
        <Ouija
          v-if="displayOuija"
          :hintList="hintList"
          @updateHints="hintList = $event"
          @incrementCounter="hints += 1"
        />
        <FourIntro v-if="displayFour" />
        <Cards
          v-if="displayCards"
          :hintList="hintList"
          @updateHints="hintList = $event"
          @incrementCounter="hints += 1"
        />
        <FiveIntro v-if="displayFive" />
        <Case
          v-if="displayCase"
          :hintList="hintList"
          @updateHints="hintList = $event"
          @incrementCounter="hints += 1"
        />
        <Lestrade
          v-if="displayLestrade"
          :errorTime="errorTime"
          @error="errorTime = $event"
          @success="victory = $event"
        />
      </transition>
    </div>
  </div>
</template>
  
<script>
import Chronometer from "./Gipsy/Chronometer.vue";
import Notes from "./Gipsy/Notes.vue";
import Intro from "./Gipsy/Intro.vue";
import Box from "./Gipsy/Box.vue";
import OneIntro from "./Gipsy/OneIntro.vue";
import TwoIntro from "./Gipsy/TwoIntro.vue";
import ThreeIntro from "./Gipsy/ThreeIntro.vue";
import FourIntro from "./Gipsy/FourIntro.vue";
import FiveIntro from "./Gipsy/FiveIntro.vue";
import Calendar from "./Gipsy/Calendar.vue";
import Crystal from "./Gipsy/Crystal.vue";
import Ouija from "./Gipsy/Ouija.vue";
import Cards from "./Gipsy/Cards.vue";
import Case from "./Gipsy/Case.vue";
import Lestrade from "./Gipsy/Lestrade.vue";
import Victory from "./Gipsy/Victory.vue";

import hintData from "./Gipsy/data.js";
import randomName from "../helpers/generateName.js";

export default {
  name: "Gipsy",
  components: {
    Chronometer,
    Intro,
    Calendar,
    OneIntro,
    TwoIntro,
    ThreeIntro,
    FourIntro,
    FiveIntro,
    Box,
    Notes,
    Crystal,
    Ouija,
    Cards,
    Case,
    Lestrade,
    Victory
  },
  data() {
    return {
      day: 0,
      displayIntro: true,
      displayOne: false,
      displayTwo: false,
      displayThree: false,
      displayFour: false,
      displayFive: false,
      displayBox: false,
      displayNotes: false,
      displayCrystal: false,
      displayOuija: false,
      displayCards: false,
      displayCase: false,
      displayLestrade: false,
      errorTime: null,
      hintList: hintData,
      hints: 0,
      notesContent: "Prends tes notes ici",
      startTime: Date.now(),
      userName: randomName,
      victory: false
    };
  },
  methods: {
    closeModale(event) {
      this.victory = event;
      this.toggleIntro();
    },
    toggleIntro() {
      this.hideAll();
      this.displayIntro ? (this.displayIntro = false) : (this.displayIntro = true);
    },
    toggleOne() {
      this.hideAll();
      this.displayOne = true;
    },
    toggleTwo() {
      this.hideAll();
      this.displayTwo = true;
    },
    toggleThree() {
      this.hideAll();
      this.displayThree = true;
    },
    toggleFour() {
      this.hideAll();
      this.displayFour = true;
    },
    toggleFive() {
      this.hideAll();
      this.displayFive = true;
    },
    toggleBox() {
      this.hideAll();
      this.displayBox = true;
    },
    toggleNote() {
      this.displayNotes = this.displayNotes ? false : true;
    },
    toggleCrystal() {
      this.hideAll();
      this.displayCrystal = true;
    },
    toggleOuija() {
      this.hideAll();
      this.displayOuija = true;
    },
    toggleCards() {
      this.hideAll();
      this.displayCards = true;
    },
    toggleCase() {
      this.hideAll();
      this.displayCase = true;
    },
    toggleLestrade() {
      this.hideAll();
      this.displayLestrade = true;
      this.day = 0;
    },
    hideAll() {
      this.displayLestrade = false;
      this.displayCase = false;
      this.displayCards = false;
      this.displayIntro = false;
      this.displayOne = false;
      this.displayTwo = false;
      this.displayThree = false;
      this.displayCrystal = false;
      this.displayBox = false;
      this.displayFour = false;
      this.displayOuija = false;
      this.displayFive = false;
    }
  },
  created() {
    console.log(this.userName);
    this.$http
      .post("https://mystery-engine.herokuapp.com/api/new", {
        game_log: {
          name: this.userName,
          duration: 0,
          enigme: "lestrade",
          status: "started",
          hint: this.hints
        }
      })
      .then(
        function(response) {
          // Success
          console.log("session started", response.data);
        },
        function(response) {
          // Error
          console.log(response.data);
        }
      );
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Libre+Caslon+Text:400,400i,700&display=swap");
html {
  margin: 0;
  padding: 0;
  height: 100%;
  max-height: 100%;
}
body {
  margin: 0;
  padding: 0;
  height: 100%;
  max-height: 100%;
}
h1 {
  font-family: "Libre Caslon Text", serif;
  color: rgb(70, 70, 70);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.container {
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100vh;
  width: 100vw;
}
.left-part {
  background-color: #f8f5de;
  background-image: linear-gradient(
    to right,
    rgba(255, 210, 0, 0.4),
    rgba(200, 160, 0, 0.1) 11%,
    rgba(0, 0, 0, 0) 35%,
    rgba(200, 160, 0, 0.1) 65%
  );
  box-shadow: inset 0 0 75px rgba(255, 210, 0, 0.3), inset 0 0 20px rgba(255, 210, 0, 0.4),
    inset 0 0 30px rgba(220, 120, 0, 0.8);
  color: rgb(80, 80, 80);
  width: 100%;
  overflow: hidden;
}
.title-bloc {
  height: calc(15vh - 20px);
  margin: 0;
  padding: 10px;
  text-align: center;
  font-family: "Libre Caslon Text", serif;
}
.title {
  width: 100%;
  font-size: 2.2vh;
  line-height: 2.2vh;
  margin: 0;
  text-align: center;
}
.subtitle-bloc {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  text-align: center;
  font-size: 2vh;
  line-height: 2vh;
}
.subtitle {
  width: 50%;
}
.illustration {
  width: 40vw;
  cursor: zoom-in;
  margin: 20px;
  border: 10px double rgb(80, 80, 80);
}
.images {
  height: 85vh;
  position: relative;
  text-align: center;
}
.notes {
  position: absolute;
  z-index: 10;
  left: 5%;
  right: calc(5% + 4mm);
  top: 10%;
  bottom: 30%;
}
.victory-modale {
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;
}
.infos {
  height: 100vh;
  max-height: 100vh;
  width: 100%;
  margin: 0;
  background-color: #f8f5de;
  background-image: linear-gradient(
    to right,
    rgba(255, 210, 0, 0.4),
    rgba(200, 160, 0, 0.1) 11%,
    rgba(0, 0, 0, 0) 35%,
    rgba(200, 160, 0, 0.1) 65%
  );
  box-shadow: inset 0 0 75px rgba(255, 210, 0, 0.3), inset 0 0 20px rgba(255, 210, 0, 0.4),
    inset 0 0 30px rgba(220, 120, 0, 0.8);
  color: rgb(80, 80, 80);
}
.elements:hover {
  opacity: 0.85;
  cursor: zoom-in;
}
.calendar-container {
  margin: 0 8% 10px 8%;
}
#box {
  position: absolute;
  height: 12%;

  bottom: 17%;
  left: 22%;
}
#table {
  position: absolute;
  height: 21%;
  bottom: 7.5%;
  left: 22%;
}
.inactive:hover {
  cursor: zoom-in;
}
.helpers:hover {
  opacity: 0.85;
  cursor: pointer;
}
.helpers {
  max-height: 30vh;
}
#envelope {
  position: absolute;
  height: 17%;
  -webkit-transform: rotate(-15deg);
  left: 3%;
  bottom: -8%;
}
#note {
  position: absolute;
  height: 30%;
  -webkit-transform: rotate(8deg);
  left: 33%;
  bottom: -21%;
}
#lestrade_card {
  position: absolute;
  height: 15%;
  -webkit-transform: rotate(-15deg);
  left: 68%;
  bottom: -6%;
}
#table_ball {
  position: absolute;
  height: 18%;
  bottom: 18%;
  left: 40%;
}
#wall_ball {
  position: absolute;
  height: 10%;
  top: 28%;
  left: 52%;
}
#wall_cards {
  position: absolute;
  height: 7%;
  top: 50%;
  right: 10%;
}
#wall_case {
  position: absolute;
  height: 13%;
  bottom: 20%;
  right: 13%;
  -webkit-transform: rotate(1deg);
}
#table-ouija {
  position: absolute;
  height: 6%;
  bottom: 15%;
  left: 35%;
  border-bottom: 3px solid black;
}
#table-cards {
  position: absolute;
  height: 10%;
  bottom: 16%;
  left: 40%;
}
#case {
  position: absolute;
  height: 18%;
  bottom: 10%;
  left: 40%;
}
</style>